import Grid from "@mui/material/Grid";
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import MDBox from "../../../components/MDBox";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import fr from "date-fns/locale/fr";
import moment from "moment";
import { useEffect } from "react";

export default function DevicePreparation({
  user,
  wait,
  setWait,
  period,
  setPeriod,
  assemblyStartContractualDate,
  setAssemblyStartContractualDate,
  setIsLastStepFormValid,
  edit,
}) {
  // Vérifier si les champs obligatoires sont remplis. Date contractuelle et
  // durée de chantier (>= 1 semaine) restent obligatoires en création
  // comme en édition.
  useEffect(() => {
    if (setIsLastStepFormValid) {
      const periodValue = parseInt(period, 10);
      const periodValid = !isNaN(periodValue) && periodValue >= 1;
      setIsLastStepFormValid(
        assemblyStartContractualDate !== null && periodValid
      );
    }
  }, [assemblyStartContractualDate, period, setIsLastStepFormValid]);

  return (
    <MDBox>
      <Grid container spacing={2}>
        {/* 1. Date contractuelle de début de montage et Durée chantier (côte à côte) */}
        <Grid item xs={6}>
          <Tooltip
            title={
              user &&
              user.role !== "Admin" &&
              user.role !== "Pilote" &&
              user.role !== "Contremaître" &&
              assemblyStartContractualDate !== null
                ? "Votre rôle ne vous permet pas de modifier cette date"
                : ""
            }
            placement="top"
          >
            <Stack component="form" noValidate>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                <DatePicker
                  slotProps={{ field: { clearable: true } }}
                  displayWeekNumber
                  label="Date contractuelle de début de montage *"
                  value={assemblyStartContractualDate ? new Date(assemblyStartContractualDate) : null}
                  onChange={(newValue) => {
                    if (newValue === null) {
                      setAssemblyStartContractualDate(null);
                    } else setAssemblyStartContractualDate(moment(newValue).format("YYYY-MM-DD"));
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  format="dd/MM/yyyy"
                  disabled={
                    user &&
                    user.role !== "Admin" &&
                    user.role !== "Pilote" &&
                    user.role !== "Contremaître" &&
                    assemblyStartContractualDate !== null
                      ? true
                      : false
                  }
                  required
                />
              </LocalizationProvider>
            </Stack>
          </Tooltip>
        </Grid>

        <Grid item xs={6}>
          <FormField
            inputProps={{ maxLength: 255, min: 1 }}
            value={period}
            onChange={(event) => setPeriod(event.target.value)}
            variant="standard"
            type="number"
            label="Durée chantier (en semaines)"
            required
          />
        </Grid>

        {/* 2. Délai fabrication appareil (en dessous) */}
        <Grid item xs={12}>
          <FormField
            inputProps={{ maxLength: 255 }}
            defaultValue={10}
            value={wait}
            onChange={(event) => setWait(event.target.value)}
            variant="standard"
            type="number"
            label="Délai fabrication appareil (en semaines)"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
